import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { LatestJourneyModel } from 'src/app/model/journey.model';

export const IsFetchingAction = createAction('[Is fetching] fetching',
  props<{ payload: boolean }>());
  
export const IsSendingAction = createAction('[Is sending] sending',
  props<{ payload: boolean }>());

export const IsLoggedInRequestAction = createAction('[User check] is logged in request');

export const LogoutRequestAction = createAction('[Logout request]');

export const GetJourneyStepsRequestAction = createAction('[System Config] get journey steps')
export const GetJourneyStepsResponseAction = createAction('[System Config] set journey steps', props<{journey:LatestJourneyModel}>())